import React from 'react'

const Unauthorized = () => {
  return <div>Not allowed!!!! try signing up or logging in!</div>
}

export default Unauthorized
